import { z } from 'zod';
/**
 * OAuth consent + "Connected apps" contracts (COS-24).
 *
 * Shared by apps/api (route validation) and apps/web (the consent page and the
 * Connected apps list) so the two cannot drift. The OAuth protocol endpoints
 * themselves (/oauth/authorize, /oauth/token, /oauth/revoke) follow the RFCs and
 * are not described here.
 */
export const oauthConsentWorkspaceSchema = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
});
/** GET /oauth/consent?req= - what the consent page shows. */
export const oauthConsentInfoSchema = z.object({
    /** Host of the client_id URL (e.g. "claude.ai") - the name to show, never self-asserted. */
    clientHost: z.string(),
    /** Host the user is sent back to. */
    redirectHost: z.string(),
    /** True for a localhost redirect (Claude Code): show the extra warning. */
    loopback: z.boolean(),
    /** Workspaces the user may connect (membership + that workspace's sign-in policy). */
    workspaces: z.array(oauthConsentWorkspaceSchema),
});
/** POST /oauth/consent */
export const oauthConsentDecisionSchema = z.discriminatedUnion('decision', [
    z.object({
        req: z.string().min(1),
        decision: z.literal('allow'),
        workspaceUuid: z.string().uuid(),
    }),
    z.object({ req: z.string().min(1), decision: z.literal('deny') }),
]);
export const oauthConsentResultSchema = z.object({
    /** Where the browser goes next: the client's redirect_uri with code or error. */
    redirectTo: z.string().url(),
});
/** GET /oauth/grants - the signed-in user's connected apps. */
export const oauthGrantSummarySchema = z.object({
    uuid: z.string().uuid(),
    clientHost: z.string(),
    clientName: z.string().nullable(),
    workspaceUuid: z.string().uuid(),
    workspaceName: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
});
//# sourceMappingURL=oauth.js.map